import React, { Component } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Form, Button, OverlayTrigger, Tooltip, Spinner, } from "react-bootstrap";
import { DailyActivityService } from "../../../../Common/Services/DailyActivity";
import { ReactPageLoader } from "../../../../Common/Components/ReactPageLoader";
import { resolve, reject } from "q";
import { Utils } from "../../../../Common/Utilis";
import { toast } from "react-toastify";
import { IRevenueEntryRequest, IRevenuePostRequest } from "../../../../Common/Contracts/IRevenueEntryRequest ";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import InputeEllipisWithTooltip from "../../../../Common/Components/InputeEllipisWithTooltip";

class Payment extends Component<any, any> {
  private scrollPos: any;
  constructor(props: any) {
    super(props);
    this.scrollPos = React.createRef();
    this.state = {
      isModified: false,
      paymentData: [],
      paymentDataCopy: [],
      paymentDataFromAPI: [],
      isDataLoading: false,
      isDataSaving: false,
      searchText: "",
      isHideEmptyRows: false,
    };
  }

  componentDidMount(): void {
    this.fetchPaymentData();
  }

  componentDidUpdate(prevProps) {
    if (
      !this.props.isLoadingDefaultDate &&
      (prevProps.selectedDate !== this.props.selectedDate ||
        prevProps.filterHotelId !== this.props.filterHotelId)
    ) {
      if (this.props.selectedDate) {
        this.setState({ paymentData: [], paymentDataCopy: [], paymentDataFromAPI: [], searchText: "", isHideEmptyRows: false, isModified: false, });
        this.props.setCurrentTabStatusOnValuesChanges(false);
        this.fetchPaymentData();
      } else {
        this.props.setCurrentTabStatusOnValuesChanges(false);
        this.setState({ paymentData: [], paymentDataCopy: [], paymentDataFromAPI: [], searchText: "", isHideEmptyRows: false, isModified: false, });
      }
    }
  }

  fetchPaymentData = async () => {
    this.setState({ isDataLoading: true });
    const { filterHotelId, selectedDate } = this.props;
    DailyActivityService.getDailyEntryRevenueDataBasedOnType(filterHotelId, selectedDate, 3)
      .then(async (result: any | null) => {
        if (result !== null) {
          let paymentData = Object.assign([], JSON.parse(JSON.stringify(result)));
          paymentData = paymentData.map((data) => ({ ...data, isEditAmt: false, isRowModified: false }))
          this.setState({ paymentData, paymentDataCopy: paymentData, paymentDataFromAPI: paymentData, isDataLoading: false }, () => {
            this.filterPaymentData();
          });
        } else {
          this.setState({ isDataLoading: false });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isDataLoading: false });
        Utils.toastError(error?.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "DA_Payments",
        });
        reject();
      });
  };

  onTotalColFocus = (e, rowIndex, row) => {
    let paymentData = Object.assign([], JSON.parse(JSON.stringify(this.state.paymentData)));
    let index = paymentData.findIndex((x) => x.itemUniqueNo === row.itemUniqueNo);
    if (index >= 0) {
      paymentData[index].isEditAmt = true;
    }
    this.setState({ paymentData });
  }

  onTotalColBlur = (e, rowIndex, row) => {
    let paymentData = Object.assign([], JSON.parse(JSON.stringify(this.state.paymentData)));
    let paymentDataCopy = Object.assign([], JSON.parse(JSON.stringify(this.state.paymentDataCopy)));
    let index1 = paymentData.findIndex((x) => x.itemUniqueNo === row.itemUniqueNo);
    let index2 = paymentDataCopy.findIndex((x) => x.itemUniqueNo === row.itemUniqueNo);
    let isInvalidNo = isNaN(e.target.value);
    if (isInvalidNo) {
      if (index1 >= 0) {
        paymentData[index1].amount = "";
      }
      if (index2 >= 0) {
        paymentDataCopy[index2].amount = "";
      }
    }
    if (index1 >= 0) {
      paymentData[index1].isEditAmt = false;
    }
    this.setState({ paymentData, paymentDataCopy });
  }

  handleInputChange = (e, rowIndex, row, type) => {
    let paymentData = Object.assign([], JSON.parse(JSON.stringify(this.state.paymentData)));
    let paymentDataCopy = Object.assign([], JSON.parse(JSON.stringify(this.state.paymentDataCopy)));
    let inputId = "";
    let cursorIndex = -1;
    let index1 = paymentData.findIndex((x) => x.itemUniqueNo === row.itemUniqueNo);
    let index2 = paymentDataCopy.findIndex((x) => x.itemUniqueNo === row.itemUniqueNo);
    if (type === "amount") {
      inputId = "totalCol_" + rowIndex;
      cursorIndex = e.target.selectionStart;
      let amount1 = Utils.removeInvaildCharFromAmount(e.target.value);
      if (index1 >= 0) {
        paymentData[index1].amount = amount1;
        paymentData[index1].isRowModified = true;
      }
      if (index2 >= 0) {
        paymentDataCopy[index2].amount = amount1;
        paymentDataCopy[index2].isRowModified = true;
      }
    } else if (type === "explanation") {
      inputId = "explanationCol_" + rowIndex;
      cursorIndex = e.target.selectionStart;
      if (index1 >= 0) {
        paymentData[index1].explanation = e.target.value;
        paymentData[index1].isRowModified = true;
      }
      if (index2 >= 0) {
        paymentDataCopy[index2].explanation = e.target.value;
        paymentDataCopy[index2].isRowModified = true;
      }
    }
    this.setState({ paymentData, paymentDataCopy, isModified: true }, () => {
      this.props.setCurrentTabStatusOnValuesChanges(true);
      $("#" + inputId).focus().prop("selectionEnd", cursorIndex);
    });
    if (!this.state.isModified) {
      setTimeout(() => {
        let offSetTop = this.scrollPos.current.childNodes[0].childNodes[0].childNodes[1].childNodes[rowIndex].offsetTop - 96;
        this.scrollPos.current?.childNodes[0]?.scrollTo({ top: offSetTop , behavior: 'smooth', });
      }, 50)
    }
  }

  hideEmptyRows = (event) => {
    this.setState({ isHideEmptyRows: event.target.checked }, () => {
      this.filterPaymentData();
    });
  }

  handleSearch = (event) => {
    this.setState({ searchText: event.target.value }, () => {
      this.filterPaymentData();
    });
  }

  filterPaymentData = () => {
    let paymentData = Object.assign([], JSON.parse(JSON.stringify(this.state.paymentDataCopy)));
    let searchedValue = this.state.searchText;

    if (searchedValue.length > 0) {
      paymentData = paymentData.filter((row) => {
        return (
          row.itemNo?.toString().toLowerCase().includes(searchedValue.toLowerCase()) ||
          row.itemName?.toLowerCase().includes(searchedValue.toLowerCase()) ||
          row.amount?.toString().toLowerCase().includes(searchedValue.toLowerCase()) ||
          row.explanation?.toLowerCase().includes(searchedValue.toLowerCase()) ||
          (row.amount === null || row.amount === "" ? false : Utils.currencyFormatWithOutdoller(row.amount)?.toLowerCase().includes(searchedValue.toLowerCase()))
        )
      });
    }

    let newPaymentData: any = Object.assign([], JSON.parse(JSON.stringify(paymentData)));

    if (this.state.isHideEmptyRows) {
      newPaymentData = [];
      for (let i = 0; i < paymentData.length; i++) {
        if (paymentData[i].amount !== null && paymentData[i].amount !== "") {
          newPaymentData.push(paymentData[i]);
        }
      }
    }
    this.setState({ paymentData: newPaymentData });
  }

  handleDiscard = () => {
    let paymentData = Object.assign([], JSON.parse(JSON.stringify(this.state.paymentDataFromAPI)));
    this.setState({ paymentData, paymentDataCopy: paymentData, isModified: false, searchText: "", isHideEmptyRows: false, });
    this.props.setCurrentTabStatusOnValuesChanges(false);
  }

  handleSave = async () => {
    let paymentData = Object.assign([], JSON.parse(JSON.stringify(this.state.paymentData)));
    let paymentDataCopy = Object.assign([], JSON.parse(JSON.stringify(this.state.paymentDataCopy)));
    const { filterHotelId, selectedDate } = this.props;

    const modifiedRows = paymentDataCopy.filter((row) => row.isRowModified);

    if (modifiedRows.length === 0) {
      toast.info("No changes to save.");
      return;
    }
    this.setState({ isDataSaving: true });
    const entries: IRevenueEntryRequest[] = modifiedRows.map((entry) => ({
      BackHid: filterHotelId,
      Date: selectedDate,
      UniqueNo: entry?.itemUniqueNo || 0,
      ItemNo: entry?.itemNo,
      ItemName: entry?.itemName,
      Amount: entry?.amount || 0,
      DebitAmount: entry?.debitAmount || 0,
      CreditAmount: entry?.creditAmount || 0,
      COA: entry?.coa || "",
      Sno: entry?.sno || 0,
      BrandCode: entry?.brandCode || 0,
      VersionCode: entry?.versionCode || 0,
      ItemUniqueNo: entry?.itemUniqueNo || 0,
      EntryType: "Single",
      TypeID: 3,
      Explanation: entry?.explanation || "",
      ExplanationReq: entry.explanationReq || "",
      UserToken: "",
    }));

    if (entries.length > 0) {
      const entriesThatHaveExplanationNotFilled = entries.filter(
        (x) => x.ExplanationReq == "yes" && !x.Explanation?.toString()?.trim() && Number(x?.Amount) !== 0
      );
      if (entriesThatHaveExplanationNotFilled.length > 0) {
        paymentDataCopy = paymentDataCopy.map((x) => {
          if (entriesThatHaveExplanationNotFilled.find((y) => y.ItemName == x.itemName)) {
            x.showExplanationRequired = true;
          } else {
            x.showExplanationRequired = false;
          }
          return x;
        });

        paymentData = paymentData.map((x) => {
          if (entriesThatHaveExplanationNotFilled.find((y) => y.ItemName == x.itemName)) {
            x.showExplanationRequired = true;
          } else {
            x.showExplanationRequired = false;
          }
          return x;
        });

        this.setState({ paymentData, paymentDataCopy, isDataSaving: false });
        toast.error(`Please provide explanation in the required fields`);
        return;
      }
    }

    const totalAmount = paymentDataCopy.reduce((acc, item: any) => Number(acc) + Number(item === null ? 0 : item?.amount), 0);

    const payload: IRevenuePostRequest = {
      totalPMS: totalAmount,
      totalDetails: totalAmount,
      variance: "0",
      requests: entries,
    };

    try {
      const response: any = await DailyActivityService.saveRevenueEntry(
        payload
      );
      const { failedCount, failedEntries } = response;

      if (failedCount > 0) {
        if (failedEntries[0]?.errorMessage !== "" && failedEntries[0]?.errorMessage !== undefined && failedEntries[0]?.errorMessage !== null ){
          toast.error(failedEntries[0]?.errorMessage);
        } else {
          toast.error(`${failedCount} entries failed to save.`);
        }
      } else {
        toast.success("Data saved successfully!");
      }
      this.props.setCurrentTabStatusOnValuesChanges(false);
      this.setState({ isModified: false, searchText: "", });
      this.fetchPaymentData();
      this.props.refreshMainData();
    } catch (error) {
      toast.error("Failed to insert payment entry.");
      console.error("Insert error:", error);
    } finally {
      this.setState({ isDataSaving: false });
    }
  };

  render() {
    const borderFormatter = (column, colIndex) => {
      return (
        <>{column.text}<div className="border-bottom"></div></>
      );
    }
    const borderFooterFormatter = (column, colIndex, { text })=>{
      return (
        <>
          <div className="border-top"></div>
          <div className="border-bottom"></div>
        </>
      );
    }
    let columns = [{
      dataField: 'itemNo',
      text: 'Item No.',
      headerClasses: 'width-150',
      headerFormatter: borderFormatter,
      footer: (columnData, column) => {
        if (this.state.searchText.length > 0 || this.state.paymentData.length === 0) {
          return "";
        }
        return (
          <>
            <div className="lable">{"Totals"}</div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        )
      },
    }, {
      dataField: 'itemName',
      text: 'Item Name',
      headerFormatter: borderFormatter,
      footerFormatter: borderFooterFormatter,
      formatter: (cell, row, rowIndex) => (
        <EllipsisWithTooltip placement="bottom">{row.itemName === null ? "" : row.itemName}</EllipsisWithTooltip>
      ),
      footer: ''
    }, {
      dataField: 'amount',
      text: 'Total',
      headerClasses: 'align-right width-140',
      classes: 'align-right',
      headerFormatter: borderFormatter,
      formatter: (cell: any, row: any, rowIndex: any) => (
        // <InputeEllipisWithTooltip placement="bottom" inputeVal={row.amount === null || row.amount === "" ? "" : Utils.currencyFormatWithOutdoller(row.amount)}>
          <Form.Control type="text"
            id={"totalCol_" + rowIndex}
            value={row.amount === null || row.amount === "" ? "" : row?.isEditAmt ? row.amount : Utils.currencyFormatWithOutdoller(row.amount)}
            className="width-124 text-right"
            onChange={(e: any) => this.handleInputChange(e, rowIndex, row, "amount")}
            onBlur={e => this.onTotalColBlur(e, rowIndex, row)}
            onFocus={e => this.onTotalColFocus(e, rowIndex, row)}
            autoComplete='off'
          />
        // </InputeEllipisWithTooltip>
      ),
      footer: (columnData, column) => {
        if (this.state.searchText.length > 0 || this.state.paymentData.length === 0) {
          return "";
        }
        let sum = columnData.reduce((acc, item) => Number(acc) + Number(item === null ? 0 : item), 0);
        return (
          <>
            <div className="value">{Utils.currencyFormat(sum)}</div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        )
      },
      footerAlign: (column, colIndex) => 'right',
    }, {
      dataField: "explanation",
      text: "Explanation",
      headerClasses: "notes-width",
      headerFormatter: borderFormatter,
      footerFormatter: borderFooterFormatter,
      formatter: (cell, row, rowIndex) => (
        row?.explanationReq !== null && row?.explanationReq.toLowerCase() === "yes" ?
          <InputeEllipisWithTooltip placement="bottom" inputeVal={row.explanation === null ? "" : row.explanation}>
            <Form.Control
              id={"explanationCol_" + rowIndex}
              value={row.explanation === null ? "" : row.explanation}
              autoComplete='off'
              onChange={(e: any) => this.handleInputChange(e, rowIndex, row, "explanation")}
              className={row?.showExplanationRequired && !row?.explanation?.toString().trim() ? "notes red-border" : "notes"}
              maxLength={999}
            />
          </InputeEllipisWithTooltip>
          : row?.explanation === null ? "" : <EllipsisWithTooltip placement="bottom">{row?.explanation}</EllipsisWithTooltip>
      ),
      footer: '',
    }, {
      dataField: "description",
      text: "",
      headerClasses: "info-width",
      footerFormatter: borderFooterFormatter,
      footer: "",
      headerFormatter: borderFormatter,
      formatter: (cell, row, rowIndex) => (
        row?.description !== null && row?.description?.trim().length > 0 ?
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-description-${rowIndex}`}>{row?.description}</Tooltip>
            }
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.25 5.25H9.75V6.75H8.25V5.25ZM8.25 8.25H9.75V12.75H8.25V8.25ZM9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15Z"
                fill="#6A6E73"
              />
            </svg>
          </OverlayTrigger>
          : <></>
      )
    }];

    return (
      this.state.isDataLoading ? (
        <ReactPageLoader useas={"revenue-nonrevenue"} />
      ) : (
        <div className='payment-section reuse-sub-design'>

          <div className='filter-section d-flex'>
            <div className='search-input'>
              <Form.Control type="text" placeholder="Search" value={this.state.searchText} onChange={(e) => this.handleSearch(e)} />
            </div>
            <div className='ml-auto'>
              <div className='togglebtn d-flex align-items-center'>
                <div className='label'>Hide Empty Rows</div>
                <Form.Check
                  id="hide-empty-row-payments"
                  type="switch"
                  checked={this.state.isHideEmptyRows}
                  onChange={this.hideEmptyRows}
                />
              </div>

            </div>
          </div>

          <div ref={this.scrollPos} className={`body-section tbl-footer ${this.state.isModified ? "footer-exist" : ""} ${this.state.searchText.length > 0 || this.state.paymentData.length === 0 ? "filter-val" : ""}`}>
            <BootstrapTable
              keyField="itemUniqueNo"
              data={this.state.paymentData}
              columns={columns}
              noDataIndication="No data found"
            />
          </div>

          {this.state.isModified &&
            <div className='footer-section d-flex align-items-center'>
              <div className='msg'>You have unsaved changes</div>
              <div className='ml-auto action'>
                <Button variant="primary" type="button" className="space btn btn-primary btn-discard" disabled={this.state.isDataSaving} onClick={() => this.handleDiscard()}>Discard</Button>
                <Button variant="primary" type="button" className="btn btn-primary" disabled={this.state.isDataSaving} onClick={() => this.handleSave()}>Save Changes</Button>
              </div>
            </div>
          }

          {this.state.isDataSaving && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}
        </div>
      )
    );
  }
}

export default Payment;